import React, { useContext, useEffect, useState } from 'react';

import Swal from 'sweetalert2';
import AuthContext from '../../../store/auth-context';
import AddAdminExperience from './AddAdminExperience';

const ViewExperience = () => {
  const context = useContext(AuthContext);
  const [experience, setExperience] = useState('');
  const [popup, setPopup] = useState(false);
  const [onClickData, setOnClickData] = useState('');
  const [onDelete, setOnDelete] = useState(false);

  const onEdit = (arg) => {
    setOnClickData(arg);
  };

  const popupChangeHandler = () => {
    setPopup(() => !popup);
  };

  const deleteItem = (arg) => {
    setOnDelete(true);
    Swal.fire({
      title: `Are you sure you want to delete ${arg.role}?`,
      showCancelButton: true,
      confirmButtonText: 'Yes',
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        fetch(`https://aifolio-api.herokuapp.com/api/user/delete/${arg._id}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
          body: JSON.stringify({
            workExperience: true,
          }),
        });
        Swal.fire('Deleted!', '', 'success');
        context.newReqHandler();
        setOnDelete(false);
      }
    });
  };

  useEffect(() => {
    const projectsArr = context.userDetails.workExperience.map((experience) => {
      return (
        <React.Fragment key={experience._id}>
          <div className='d-flex flex-column flex-wrap mb-2'>
            <small>{experience.year}</small>
            <h4>{experience.role}</h4>
            <p>{experience.description.shortDescription}</p>
          </div>

          <div className='d-flex justify-content-end flex-wrap'>
            <button
              className='ms-3 mb-3 cursor'
              onClick={() => {
                onEdit(experience);
                popupChangeHandler();
              }}
            >
              Edit
            </button>
            <button
              className=' mb-3 cursor'
              onClick={() => deleteItem(experience)}
            >
              Delete
            </button>
          </div>
        </React.Fragment>
      );
    });
    setExperience(projectsArr);
  }, [popup, onDelete, context]);

  return (
    <>
      {experience}
      {popup && (
        <div className={popup ? 'pop-up' : ''}>
          <div className='popup-btn-div '>
            <p className='popup-btn' onClick={popupChangeHandler}>
              X
            </p>
          </div>
          <AddAdminExperience
            onClickData={onClickData}
            popupChangeHandler={popupChangeHandler}
          />
        </div>
      )}
    </>
  );
};

export default ViewExperience;
